import React from 'react';
import { motion } from 'framer-motion';
import { TargetIcon, SnowflakeIcon, AnchorIcon } from './Icons';
export function HowItWorks() {
  return <section className="w-full bg-beige py-10 md:py-24 px-5" data-id="element-266">
      <div className="max-w-2xl mx-auto" data-id="element-267">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="font-heading text-2xl md:text-4xl font-bold text-brown-dark text-center mb-4" data-id="element-268">
          Cómo Funciona
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="font-body text-warm-gray text-center mb-14 text-lg" data-id="element-269">
          3 pasos simples hacia la recuperación
        </motion.p>

        <div className="relative" data-id="element-270">
          {/* Connecting line */}
          <div className="absolute left-7 md:left-8 top-12 bottom-12 w-px bg-gold/30 hidden md:block" data-id="element-271" />

          <div className="space-y-7 md:space-y-12" data-id="element-272">
            {/* Step 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 25
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="flex gap-5 md:gap-6 items-start" data-id="element-273">
              <div className="flex-shrink-0 relative" data-id="element-274">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-gold flex items-center justify-center shadow-md" data-id="element-275">
                  <TargetIcon className="w-7 h-7 text-white" data-id="element-276" />
                </div>
                <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-brown-dark text-white font-body text-sm font-bold flex items-center justify-center" data-id="element-277">
                  1
                </span>
              </div>
              <div className="pt-2" data-id="element-278">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-brown-dark mb-2" data-id="element-279">
                  Identificas
                </h3>
                <p className="font-body text-base md:text-lg text-brown-medium leading-relaxed" data-id="element-280">
                  Usas el mapa de calor para localizar dónde está sufriendo tu
                  cuero cabelludo.
                </p>
              </div>
            </motion.div>

            {/* Step 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 25
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="flex gap-5 md:gap-6 items-start" data-id="element-281">
              <div className="flex-shrink-0 relative" data-id="element-282">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-gold flex items-center justify-center shadow-md" data-id="element-283">
                  <SnowflakeIcon className="w-7 h-7 text-white" data-id="element-284" />
                </div>
                <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-brown-dark text-white font-body text-sm font-bold flex items-center justify-center" data-id="element-285">
                  2
                </span>
              </div>
              <div className="pt-2" data-id="element-286">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-brown-dark mb-2" data-id="element-287">
                  Enfrías
                </h3>
                <p className="font-body text-base md:text-lg text-brown-medium leading-relaxed" data-id="element-288">
                  Aplicas el elixir casero para detener la inflamación y el
                  picor de raíz.
                </p>
              </div>
            </motion.div>

            {/* Step 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 25
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="flex gap-5 md:gap-6 items-start" data-id="element-289">
              <div className="flex-shrink-0 relative" data-id="element-290">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-gold flex items-center justify-center shadow-md" data-id="element-291">
                  <AnchorIcon className="w-7 h-7 text-white" data-id="element-292" />
                </div>
                <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-brown-dark text-white font-body text-sm font-bold flex items-center justify-center" data-id="element-293">
                  3
                </span>
              </div>
              <div className="pt-2" data-id="element-294">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-brown-dark mb-2" data-id="element-295">
                  Anclas
                </h3>
                <p className="font-body text-base md:text-lg text-brown-medium leading-relaxed" data-id="element-296">
                  Sigues la nutrición y el lavado de presión cero para
                  fortalecer el agarre del cabello nuevo.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}